import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MatDialogRef} from '@angular/material';

import {ProfileService} from '../../profile/profile.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ProfileValidator} from '../../profile/profile.validators';
import {Profile} from '../../profile/profile.model';
import {PlatformConfig} from '../../app-loader/platform-config';
import {ConfigLoaderService} from '../../app-loader/config-loader.service';

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.scss']
})
export class ChangePasswordDialogComponent implements OnInit, OnChanges {

  form: FormGroup;
  loading: boolean = false;

  passwordChanged: boolean = false;

  message = null;
  errorMsg = null;

  profile: Profile;

  platformConfig: PlatformConfig;

  hideOldPassword = true;
  hideNewPassword = true;
  hideConfirmPassword = true;

  constructor(public dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
              private profileService: ProfileService,
              private fb: FormBuilder,
              private profileValidator: ProfileValidator,
              public configLoaderService: ConfigLoaderService) {
    this.platformConfig = this.configLoaderService.getPlatformConfig();
    this.profile = profileService.getProfileData();

    this.profileService.getProfile().subscribe(
      (profile: Profile) => {
        this.profile = profile;
      }
    );
  }

  ngOnInit() {
    this.form = this.fb.group({
      oldPassword: [
        null,
        Validators.compose([Validators.required ])
      ],
      plainPasswordFirst: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          ProfileValidator.differentFromField('oldPassword')
        ])
      ],
      plainPasswordSecond: [
        null,
        Validators.compose([
          Validators.required,
          this.profileValidator.confirmPassword
        ]),
        Validators.composeAsync([])
      ]
    });

    this.form.controls['oldPassword'].valueChanges.subscribe(() => {
      this.form.controls['plainPasswordFirst'].updateValueAndValidity({onlySelf: true});
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  togglePasswordVisibility(field: 'old' | 'new' | 'confirm') {
    if (field === 'old') {
      this.hideOldPassword = !this.hideOldPassword;
    } else if (field === 'new') {
      this.hideNewPassword = !this.hideNewPassword;
    } else {
      this.hideConfirmPassword = !this.hideConfirmPassword;
    }
  }

  onSubmit() {
    this.errorMsg = null;
    this.loading = true;
    const data = {
      'oldPassword': this.form.value.oldPassword,
      'plainPassword': {
        'first': this.form.value.plainPasswordFirst,
        'second': this.form.value.plainPasswordSecond
      }
    };
    this.form.disable();

    this.profileService.putPassword(data).subscribe(
      (response) => {
        this.message = 'YOUR PASSWORD HAS BEEN SUCCESSFULLY UPDATED';
        this.form.enable();
        this.loading = false;
        this.passwordChanged = true;
      },
      (error) => {
        let errorMsg = '';
        if (error.error.children) {
          if (error.error.children.oldPassword.errors) {
            errorMsg += error.error.children.oldPassword.errors[0];
          }else if (error.error.children.plainPassword.children.first.errors) {
            errorMsg += error.error.children.plainPassword.children.first.errors[0];
          }
        }
        this.errorMsg = errorMsg;
        this.form.enable();
        this.loading = false;
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/change-password-dialog/change-password-dialog.component.ts